import { createAsyncAction } from "typesafe-actions";

import * as T from "./types";

export const fetchDashboardMeta = createAsyncAction(
  "FETCH_DASHBOARD_META_DATA_REQUEST",
  "FETCH_DASHBOARD_META_DATA_SUCCESS",
  "FETCH_DASHBOARD_META_DATA_FAILURE"
)<void, T.DashboardMeta, void>();

export const fetchBenchmarkAnalysis = createAsyncAction(
  "FETCH_BENCHMARK_ANALYSIS_REQUEST",
  "FETCH_BENCHMARK_ANALYSIS_SUCCESS",
  "FETCH_BENCHMARK_ANALYSIS_FAILURE"
)<string, { exchange: string; data: T.BenchmarkAnalysis }, void>();

export const fetchSectorIndustryPerf = createAsyncAction(
  "FETCH_SECTOR_INDUSTRY_PERFORMANCE_REQUEST",
  "FETCH_SECTOR_INDUSTRY_PERFORMANCE_SUCCESS",
  "FETCH_SECTOR_INDUSTRY_PERFORMANCE_FAILURE"
)<void, T.Performance, void>();
